import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import Checkbox from '@material-ui/core/Checkbox';
import MinimalSelect from '../../ui/MinimalSelect';
import { Field, TextField, CheckboxField } from '../UI';
import EditorContext from '../../../modules/contexts/editor';
import { fieldsByName } from '../../../modules/libs/lessonLib';

import deletePNG from '../../../assets/images/delete.png';
import { colorChoices } from '../../../modules/defines/style';

const BoxWrapper = styled.div`
    border-bottom: thin solid lightgray;
`;

const PatternWrapper = styled(Field)`
    display: table;
`;
const PatternRow = styled.div`
    display: table-row;
    flex-direction: row;
`;
const PatternField = styled.div`
    display: table-cell;
    max-width: min-content;
    position: relative;
`;
const Value = styled(TextField)`
    padding-right: 0px;
`;
const ColorSelect = styled(MinimalSelect)`
    width: 70px;
`;
const Underline = styled(Checkbox)`
    width: 11px;
    height: 0px;
    color: #9a9a9a !important;
`;
const BoxName = styled.div`
    font-weight: bold;
    margin: 8px 0 8px 10px;
    font-size: 12px;
`;

const Delete = styled.img`
    width: 24px;
    content: url(${deletePNG});
    align-self: center;
    cursor: pointer;
    position: absolute;
    bottom: 6px;
    left: -10px
`;
const AddBox = styled.div`
    font-weight: bold;
    border: thin solid #ababab;
    border-radius: 50%;
    cursor: pointer;
    padding: 2px;
    margin: 8px 8px;
    width: 17px;
    height: 17px;
    text-align: center;
    font-size: 16px;
    background-color: #ffffff;
`;

export const PatternBox = ({ node, field }) => {
    const editor = useContext(EditorContext);

    const onCheckboxChange = (e, prop) => {
        editor.updateElementField(node, field, prop, e.target.checked);
        editor.commitNodeUpdate(node);
    };

    const subfieldChanged = (pn, i, subfield, value) => {
        editor.updateElementFieldPart(node, field, pn, i, subfield, value);
        editor.commitNodeUpdate(node);
    };

    const addRow = (e, pn) => {
        const newParts = [...field.parts[pn]];
        newParts.push(field.newPart ? { ...field.newPart } : { ...(newParts[0]) });
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
    };

    const deleteRow = (e, pn, i, p) => {
        const newParts = [...field.parts[pn]];
        newParts.splice(i, 1);
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
    };

    return (
        <BoxWrapper>
            <PatternWrapper>
                <PatternRow>
                    <PatternField style={{ paddingLeft: 15 }}>Top word</PatternField>
                    { fieldsByName(node, 'form') && fieldsByName(node, 'form').value === 'Ko + En' && !field.topOnly && <PatternField>Bottom word</PatternField> }
                    <PatternField>Color</PatternField>
                    <PatternField>BG Color</PatternField>
                    <PatternField>Hidden</PatternField>
                </PatternRow>
                { field.parts.words.map(p => editor.repairColor(p)).map((p, i) => (
                    <PatternRow key={`${i}`}>
                        <PatternField><Value inputRef={input => { if (input) input.value = p.top; }} onBlur={e => subfieldChanged('words', i, 'top', e.target.value)} /></PatternField>
                        { fieldsByName(node, 'form') && fieldsByName(node, 'form').value === 'Ko + En' && !field.topOnly
                            && <PatternField><Value inputRef={input => { if (input) input.value = p.bottom; }} onBlur={e => subfieldChanged('words', i, 'bottom', e.target.value)} /></PatternField>}
                        <PatternField style={{ width: 68 }}><ColorSelect options={colorChoices} value={p.color} onSelect={e => subfieldChanged('words', i, 'color', e.target.value)} /></PatternField>
                        <PatternField style={{ width: 68 }}><ColorSelect options={colorChoices} value={p.bgColor} onSelect={e => subfieldChanged('words', i, 'bgColor', e.target.value)} /></PatternField>
                        <CheckboxField checked={p.hidden || false} onChange={e => subfieldChanged('words', i, 'hidden', e.target.checked)} />
                        <PatternField>{ field.parts.words.length > 1 && <Delete onClick={e => deleteRow(e, 'words', i, p)} /> }</PatternField>
                    </PatternRow>
                ))}
                <AddBox onClick={e => addRow(e, 'words')}>+</AddBox>
            </PatternWrapper>
            { (field.arrows || field.arrows === undefined)
                && (
                    <>
                        <CheckboxField label="Arrow target" checked={field.arrowTarget || false} onChange={e => onCheckboxChange(e, 'arrowTarget')} />
                        <CheckboxField label="Arrow source" checked={field.arrowSource || false} onChange={e => onCheckboxChange(e, 'arrowSource')} />
                    </>
                )}
            { field.spaceAfter !== undefined && <CheckboxField label="Space after" checked={field.spaceAfter} onChange={e => onCheckboxChange(e, 'spaceAfter')} /> }
        </BoxWrapper>
    );
};
